import script from "./JoinComp.vue?vue&type=script&setup=true&lang=js"
export * from "./JoinComp.vue?vue&type=script&setup=true&lang=js"

import "./JoinComp.vue?vue&type=style&index=0&id=63a9255e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63a9255e"]])

export default __exports__